import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class Tabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = { activeTab: 0 }
  }

  componentDidMount() {
    if (this.props.defaultTab !== 0) {
      this.onTabSelected(this.props.defaultTab)
    }
  }

  onTabSelected(index) {
    if (index !== this.state.activeTab) {
      this.setState({ activeTab: index })

      if (this.props.onTabSelected) {
        this.props.onTabSelected(index)
      }
    }
  }

  render() {
    let tabBlock = null
    if (this.props.stretch) {
      tabBlock = midas.tabBlock
    }

    return (
      <div>
        <section>
          {this.props.tabRowActive && (
            <ul className={`${midas.tab} ${tabBlock}`}>
              {this.props.content.map((tab, index) => (
                <li
                  style={{ marginBottom: '.2rem' }}
                  key={tab.title}
                  className={`${midas.tabItem} ${
                    index === this.state.activeTab ? midas.active : null
                  } `}
                >
                  <button onClick={() => this.onTabSelected(index)}>
                    {tab.title}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </section>
        <section>
          {this.props.content.map(
            (tab, index) =>
              index === this.state.activeTab && (
                <article key={tab.title}>{tab.body}</article>
              ),
          )}
        </section>
      </div>
    )
  }
}

Tabs.defaultProps = {
  stretch: false,
  tabRowActive: true,
  defaultTab: 0,
  onTabSelected: null,
}

Tabs.propTypes = {
  content: PropTypes.array.isRequired,
  stretch: PropTypes.bool,
  tabRowActive: PropTypes.bool,
  defaultTab: PropTypes.number,
  onTabSelected: PropTypes.func,
}
